import type { ChallengeInfo } from "@/sales-tools/challenges/api/getChallengesForEmployee";
import { findMyTeam } from "@/sales-tools/challenges/utils/findMyTeam";
import { isDisqualified } from "@/sales-tools/challenges/utils/isDisqualified";
import { userCache } from "@/shared-utils";

/*
 * Given an array of challenges, return the announcements to be displayed in the correct order
 */
export const findUnackedAnnouncements = (challenges: ChallengeInfo[] | undefined) => {
    // Always prioritize ackEnds over ackStarts
    if (!challenges) return undefined;

    // find all challenges with no ackEnd and either no finishDate or the employees team is disqualified
    const ackEnds = challenges
        .filter(
            (c) =>
                !c.announcement.ackEnd &&
                (!!findMyTeam(c.details, userCache.employeeId!).finishDate ||
                    isDisqualified(findMyTeam(c.details, userCache.employeeId!).conditions)),
        )
        .sort(
            (a, b) =>
                new Date(findMyTeam(a.details, userCache.employeeId!).finishDate!).getTime() -
                new Date(findMyTeam(b.details, userCache.employeeId!).finishDate!).getTime(),
        );
    const ackStarts = challenges
        .filter((c) => !c.announcement.ackStart && !findMyTeam(c.details, userCache.employeeId!).finishDate)
        .sort((a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime());
    return { ackEnds, ackStarts };
};
